































































import Vue from 'vue';
import { Type, TypeMap, Expression, ExpressionMap, NoExpression, TemplateExpression, objectMap, objectValues, ObjectType, Types } from 'expangine-runtime';
import { obj } from '@/common';
import { getConfirmation } from '../../../app/Confirm';
import ExpressionBase from '../ExpressionBase';
import { Preferences, PreferenceCategory } from '../../../app/Preference';


const PREF_REMOVE_VAR = Preferences.define({
  key: 'template_remove_var',
  label: 'Remove Template expression vars without confirmation',
  category: [PreferenceCategory.EXPRESSION, PreferenceCategory.CONFIRM],
  defaultValue: false,
});


export default ExpressionBase<TemplateExpression>().extend({
  name: 'TemplateEditor',
  data: () => ({
    vars: [] as string[],
  }),
  computed: {
    paramType(): Type {
      return Types.many(
        Types.text(), 
        Types.number(), 
        Types.enum(Types.many(Types.text(), Types.number()), Types.any()),
      );
    },
  },
  watch: {
    value: {
      immediate: true,
      handler(template: string) {
        this.parseVars();
      },
    },
  },
  methods: {
    parseVars(): string[] {
      this.vars = this.value.template
        .split(/[\}\{}]/)
        .filter((v, i) => (i % 2) === 1)
        .filter((v) => v)
      ;

      return this.vars;
    },
    addDefinedVars() {
      const oldVars = this.vars;
      const newVars = this.parseVars();

      const common = obj();
      for (const oldVar of oldVars) {
        if (newVars.indexOf(oldVar) !== -1) {
          common[oldVar] = true;
        }
      }

      const params = this.value.params;

      let oldIndex = 0;
      for (const newVar of newVars) {
        if (!common[newVar]) {
          while (oldIndex < oldVars.length && common[oldVars[oldIndex]]) {
            oldIndex++;
          }
          if (oldIndex < oldVars.length) {
            const oldVar = oldVars[oldIndex];
            if (!params[newVar]) {
              this.$set(params, newVar, params[oldVar]);
              this.$delete(params, oldVar);
            }
          }
        }
      }
      
      for (const varName of newVars) {
        if (!params[varName]) {
          this.$set(params, varName, NoExpression.instance);
        }
      }
    },
    isVarInvalid(name: string): boolean {
      return !!this.value.params[name] && this.vars.indexOf(name) === -1;
    },
    saveVar(name: string, expr: Expression) {
      this.$set(this.value.params, name, expr);
      this.update();
    },
    renameVar(name: string, newName: string) {
      const params = this.value.params;
      const expr = params[name];
      this.$delete(params, name);
      if (newName) {
        this.$set(params, newName, expr);
      }
      this.addDefinedVars();
      this.update();
    },
    async removeVar(name: string) {
      if (await getConfirmation({ pref: PREF_REMOVE_VAR })) {
        this.$delete(this.value.params, name);
        this.addDefinedVars();
        this.update();
      }
    },
  },
});
